import React from "react";
import "./App.scss";

// Components
import Router from "routes/Router";
import MousePointer from "components/MousePointer/MousePointer";
import Menu from "components/Menu/Menu";

// Libraries & Packages
import { ReactLenis } from "@studio-freight/react-lenis";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// State
import { useMenuStore } from "utils/state/Store";

// Utils
import useWindowWidth from "lib/Contentful/hooks/useWindowWidth";

function App() {
  // State
  const { toggleMenu } = useMenuStore();
  const windowWidth = useWindowWidth();

  return (
    <BrowserRouter>
      <div className="App">
        {/* <UnderDevelopment /> */}
        <Menu />
        {!toggleMenu ? (
          <ReactLenis root>
            <Router />
          </ReactLenis>
        ) : (
          <Router />
        )}
        {windowWidth > 600 && <MousePointer />}
        <ToastContainer />
      </div>
    </BrowserRouter>
  );
}

export default App;
